import { Button, HFlow, Text, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { DateTime } from 'components/date'
import { Form, FormRenderProps } from 'components/form/core/Form'
import { confirm } from 'components/modals/confirm'
import { useDesativarAgendaOnlineMutation } from 'graphql/hooks.generated'

import { ConfiguracaoAgendaOnline } from './ConfiguracaoAgendaOnlineBox'
import { ConfiguracaoAgendaOnlineTesteConexao } from './ConfiguracaoAgendaOnlineTesteConexao'
import { DesativarAgendaOnlineConfirmBody } from './DesativarAgendaOnlineConfirmBody'

export interface ConfiguracaoAgendaOnlineHabilitadoContentProps {
  agendaOnline: ConfiguracaoAgendaOnline
  refetch(): void
}

export function ConfiguracaoAgendaOnlineHabilitadoContent(
  props: Readonly<ConfiguracaoAgendaOnlineHabilitadoContentProps>
) {
  const { agendaOnline } = props
  const { detalhesAtivacao, testeConexao } = agendaOnline ?? {}

  const alert = useAlert()
  const [desativarAgendaOnline, { loading }] = useDesativarAgendaOnlineMutation()

  const handleDesativar = (formProps: FormRenderProps) => () => {
    return confirm({
      body: <DesativarAgendaOnlineConfirmBody />,
      title: `Deseja desabilitar a agenda online?`,
      type: 'danger',
      confirmLabel: 'Desabilitar',
      onConfirm: formProps.form.submit,
    })()
  }

  const handleSubmit = async () => {
    await desativarAgendaOnline()
    alert('success', 'Conexão com a agenda online foi desabilitada com sucesso.')
    props.refetch()
  }

  const renderForm = (formProps: FormRenderProps) => {
    return (
      <Button kind='primary' size='small' onClick={handleDesativar(formProps)} loading={loading}>
        Desabilitar
      </Button>
    )
  }

  return (
    <VFlow>
      <HFlow alignItems='center' justifyContent='space-between'>
        <Form onSubmit={handleSubmit} render={renderForm} />
        <Text>
          Habilitada por {detalhesAtivacao?.profissional?.nome} em <DateTime value={detalhesAtivacao?.dataEvento} />.
        </Text>
      </HFlow>

      <ConfiguracaoAgendaOnlineTesteConexao testeConexao={testeConexao} refetch={props.refetch} loading={loading} />
    </VFlow>
  )
}
